export default __webpack_public_path__ + "static/media/loading.da5e1996.svg";